






























































































































































import Vue from 'vue';
import { CreateScan, CreateScanAPIReturn, ScanResponseObject, ReservationEntity } from '../../../types';
import { apiPostRequest, logError } from '../helpers';

const apiBaseURL = process.env.VUE_APP_API_URL || '';

export default Vue.extend({
  name: 'response',
  props: {
    qrCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      scanResponse: null as ScanResponseObject | null,
    };
  },
  async mounted() {
    if (!(this as any).currentLocationSecurityScanningCode || !(this as any).currentLocationId || !(this as any).apiKey) {
      this.$store.commit('appData/REMOVE_LOGIN_DATA');

      this.$router.push({ name: 'login' });
    }

    (this as any).startLoading();

    await this.scanQRCode();

    (this as any).stopLoading();
  },
  computed: {
    timeslotTimes(): { startTime: string | null; endTime: string | null } {
      return {
        startTime:
          this.scanResponse && this.scanResponse.reservation
            ? this.scanResponse.reservation.timeslot
              ? this.scanResponse.reservation.timeslot.startTime
              : this.scanResponse.reservation.manualGroup
              ? this.scanResponse.reservation.manualGroup.startTime
              : null
            : null,
        endTime:
          this.scanResponse && this.scanResponse.reservation
            ? this.scanResponse.reservation.timeslot
              ? this.scanResponse.reservation.timeslot.endTime
              : this.scanResponse.reservation.manualGroup
              ? this.scanResponse.reservation.manualGroup.endTime
              : null
            : null,
      };
    },
    allDay(): boolean {
      const startTime = this.timeslotTimes && this.timeslotTimes.startTime;
      const endTime = this.timeslotTimes && this.timeslotTimes.endTime;

      return startTime !== null && endTime !== null && ['00:00:00', '00:00:01'].includes(startTime) && ['23:59:59', '00:00:00'].includes(endTime);
    },
  },
  methods: {
    async scanQRCode(): Promise<void> {
      const postBody: CreateScan = {
        securityScanningCode: (this as any).currentLocationSecurityScanningCode,
        qrCode: this.qrCode,
        ...((this as any).currentLocationEntranceId && {
          entranceId: parseInt((this as any).currentLocationEntranceId, 10),
        }),
        ...((this as any).externalUserId && {
          externalUserId: (this as any).externalUserId,
        }),
      };

      const apiReturnRaw: any = await apiPostRequest({
        apiKey: (this as any).apiKey || '',
        apiURL: `${apiBaseURL}customer/${(this as any).customerId}/location/${(this as any).currentLocationId}/scan`,
        postBody,
      });

      const apiReturn: CreateScanAPIReturn = apiReturnRaw.hasOwnProperty('success') ? apiReturnRaw : apiReturnRaw.data;

      if (apiReturn.errorCode === 'NOT_AUTHORIZED') {
        this.$store.commit('appData/REMOVE_LOGIN_DATA');

        this.$router.push({ name: 'login' });
      }

      const reservation: ReservationEntity | null = apiReturn && apiReturn.data ? apiReturn.data : null;

      if (reservation && reservation.scans) {
        const newLocationData = reservation.location;

        if (newLocationData) {
          this.$store.commit('appData/SET_LOCATION', newLocationData);
        }

        const latestScan = reservation.scans.length ? reservation.scans.reduce((prev, current) => (prev.id > current.id ? prev : current)) : null;

        const successPhrase = latestScan ? (latestScan.type === 1 ? this.$t(`text.entry_approved`) : this.$t(`text.exit_approved`)) : null;

        this.scanResponse = {
          approved: apiReturn.success,
          message: apiReturn.rejectionReasonCode ? this.$t(`text.${apiReturn.rejectionReasonCode.toLowerCase()}`) : successPhrase,
          reservation,
          rejectionCode: apiReturn.rejectionReasonCode || null,
        };
      } else {
        this.scanResponse = {
          approved: false,
          message: this.$t(`text.invalid_qr_code`),
          reservation: null,
          rejectionCode: 'INVALID_QR_CODE',
        };
      }
    },
    clearResponse(): void {
      this.$router.push({ name: 'scan' });
    },
  },
});
